import  axiosDefault, { AxiosInstance, AxiosPromise } from 'axios';

class Client {

    axios: AxiosInstance
    private _token: string | null = null
    private _baseUrl = ""
   
   
    constructor (baseURL = "" ) {
        this.axios = axiosDefault.create({
            baseURL
        })
    }

    set baseUrl(baseUrl: string) {
        this.axios.defaults.baseURL = baseUrl;
        this._baseUrl=baseUrl
    }

    get baseUrl(): string  {
        return this._baseUrl
    }

    set token(token: string | null) {
        this._token = token;

        let headers = {}

        if (token != null) {
            headers = { "Authorization" : "Bearer " + token};
        }

        this.axios.defaults.headers = headers
    }

    get token(): string | null {
        return this._token
    }


    get(urlPath: string): AxiosPromise {
        return this.axios.get(urlPath);
    }

    post(urlPath: string, data: object = {}, options: object = {}): AxiosPromise {
         return this.axios.post(urlPath, data, options)
    }

}

function saveToken(token: string) {
    window.sessionStorage.setItem('t', token);
}

function loadToken(): string | null {
    const t = window.sessionStorage.getItem('t');
    console.log(t);
    return t;
}

function removeToken() {
    window.sessionStorage.removeItem('t');
}

function isLoggedIn(): boolean {
    return loadToken() != null
}

export {
    Client,
    saveToken,
    loadToken,
    removeToken,
    isLoggedIn
}
